import React from 'react';

import { DesktopAboutUs } from './DesktopAboutUs';
import { DesktopAboutUsContainerProps } from './types';
import { MODE_OPTIONS } from '../../../../../components/HorizontalSlides/constants';
import { PageOption } from '../../../../../components/HorizontalSlides/types';
import { INTRO_PANELS_OPTIONS } from '../../../../../constants/AboutData';

type PageProps = {
  title: string;
  text: string;
}

const Page: React.FC<PageProps> = ({ title, text }) => {
  return(
    <>
      <h1>
        {title}
      </h1>
      <p>
        {text}
      </p>
    </>
  );
};

const DesktopAboutUsContainer: React.FC<DesktopAboutUsContainerProps> = ({ goToPrediction }) => {
  const pagesOptions = INTRO_PANELS_OPTIONS.map((data, index): PageOption => {
    return {
      page: <Page text={data.text} title={data.title}/>,
      button: {
        text: data.buttonText,
        mode: (index + 1) ===  INTRO_PANELS_OPTIONS.length ? MODE_OPTIONS.PRIMARY as 'primary' : MODE_OPTIONS.SECONDARY as 'secondary',
        onClick: undefined,
      }
    };
  });

  pagesOptions[pagesOptions.length - 1].button.onClick = goToPrediction;
  return (
    <DesktopAboutUs
      pagesOptions={pagesOptions}
    />
  );
};

export default DesktopAboutUsContainer;
